export default __webpack_public_path__ + "static/media/ic_cart_active.9bdaefb5.svg";